import { get, post, getCached } from '../Http';

export const getStores = async (params = {}) => {
    try {
        const queryParams = {
            all: true,
            filters: JSON.stringify({ status: 1, limit: 1000, ...params })
        };
        const response = await getCached(`${process.env.EXTENDED_URL}store`, queryParams, 5 * 60 * 1000);
        return response.data;
    } catch (error) {
        console.error('Error fetching stores:', error);
        throw error;
    }
};

/**
 * Sync Category & Product with PMS
 * @param {string} storeId - Store ID to sync (optional, defaults to localStorage store_id)
 * @returns {Promise} Creation response
 */
export const syncCategoryAndProductWithPms = async (storeId = null) => {
    try {
        const apiData = {
            store_id: storeId || localStorage.getItem('store_id') || "",
        };
        const response = await post(`${process.env.EXTENDED_URL}/pms-sync/run-full-sync`, apiData);
        return response.data;
    } catch (error) {
        console.error('Error syncing category and product with PMS:', error);
        throw error;
    }
};
